/**
 * Store map zoom and center to localstorage
 */
export default {
    methods: {
        /**
         * save map position to localStorage
         */
        saveMapPosition(namespace = 'bcwt') {
            const centerKey = `mapPositionCenter:${namespace}`;
            const zoomKey = `mapPositionzoom:${namespace}`;
            const map = this.map;
            const center = map.getCenter();
            const zoom = map.getZoom();
            localStorage.setItem(centerKey, JSON.stringify(center));
            localStorage.setItem(zoomKey, zoom);
        },
        /**
         * return saved map position from local storage, if available
         * otherwise, return some defaults
         * @return {Object} object with map center and zoom
         */
        loadMapPosition(namespace = 'bcwt') {
            const centerKey = `mapPositionCenter:${namespace}`;
            const zoomKey = `mapPositionzoom:${namespace}`;
            let center = localStorage.getItem(centerKey);
            center = JSON.parse(center);
            const zoom = localStorage.getItem(zoomKey);

            return {
                center,
                zoom,
            };
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/saveMapPosition.js